import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "react-axios";

import styled from "styled-components";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { useUser } from "~/Context/userContext";
import { postPlaylistDetailsEdit } from "~/api/getCustomPlaylists";

function validate(values) {
  let errors = {};
  if (!values.title || values.title.trim() === "" || values.title.trim().replace(/<[^>]*>?/gm, "") === "") {
    errors.title = "Please enter a playlist title.";
  }
  return errors;
}

const usePlaylistEditForm = (initialFormValues, callback, validate) => {
  const [inputs, setInputs] = useState(initialFormValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
  }, [errors]);
  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => ({ ...inputs, [event.target.name]: event.target.value }));
  };
  const clearForm = () => {
    setInputs(initialFormValues);
  };
  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setErrors(validate(inputs));
    setIsSubmitting(true);
  };

  return {
    handleInputChange,
    handleSubmit,
    inputs,
    clearForm,
    errors,
  };
};

export const Wrapper = styled.section`
  margin: 10px 0 10px 0;
`;
export const TipsWrapper = styled.section`
  display: inline;
  float: right;
`;

const PlaylistEditForm = ({ playlist, onComplete }) => {
  let history = useHistory();
  const { state: userState } = useUser();
  const [loading, setLoading] = useState(true);

  const initialFormValues = {
    title: playlist.name,
    description: playlist.description || "",
  };

  useEffect(() => {
    setLoading(!userState.loaded);
  }, [userState.loaded]);

  const postTrackEdit = async () => {
    setLoading(true);

    const payload = {
      playlistId: playlist.id,
      title: inputs.title,
      description: inputs.description,
    };

    const doJobs = async () => {
      const resultA = await postPlaylistDetailsEdit(axios, payload);
      return [];
    };
    doJobs()
      .then((result) => {
        setLoading(false);
        onComplete();
      })
      .catch((e) => {
        console.log("e:", e);
        setLoading(false);
      });
  };

  const backButton = () => {
    history.push(`/playlist/${playlist.id}`);
  };

  const { inputs, handleInputChange, handleSubmit, errors } = usePlaylistEditForm(initialFormValues, postTrackEdit, validate);

  return (
    <Wrapper className="TrackEditWrapper">
      <Form className="totd-form topic-edit-form" noValidate onSubmit={(e) => handleSubmit(e)}>
        <Form.Group as={Row} className={errors.subject ? "error" : ""}>
          <Col md={1}>
            <Form.Label>Title:</Form.Label>
          </Col>
          <Col md={6}>
            <Form.Control name="title" onChange={handleInputChange} value={inputs.title || ""} type="text" autoComplete="off" />
            {errors.title && <span className="help error">{errors.title}</span>}
          </Col>
        </Form.Group>
        <Form.Group controlId="description" className={errors.description ? "error" : ""}>
          <Form.Label>Description:</Form.Label>
          <Form.Control
            disabled={loading}
            name="description"
            onChange={handleInputChange}
            value={inputs.description.replace(/<br\s*\/?>/gm, "\n") || ""}
            as="textarea"
            rows="2"
          />
        </Form.Group>

        <Button disabled={loading} variant="success" type="submit">
          Save
        </Button>
        <Button onClick={(e) => backButton(e)} disabled={loading} variant="cancel" type="cancel">
          Cancel
        </Button>
      </Form>
    </Wrapper>
  );
};

export default PlaylistEditForm;
